export default (host: string) => ({
  '@id': 'organization',
  'address': {
    '@type': 'PostalAddress',
    'addressCountry': 'CH',
    'addressLocality': 'Stabio',
    'addressRegion': 'Ticino',
    'postalCode': '6855',
    'streetAddress': 'Via Laveggio 5'
  },
  'areaServed': 'SE',
  'brand': {
    '@type': 'Brand',
    '@id': `https://${host}/en-se#brand`,
    'name': 'Timberland',
    'description': 'Timberland is Built for the Bold. We inspire and equip adventurers to get outside, work hard and move the world forward.',
    'url': `https://${host}/en-se`,
    'image': `https://${host}/img/logo50.svg`
  },
  'contactPoint': [
    {
      '@type': 'ContactPoint',
      'telephone': '020.792.059',
      'contactType': 'Telephone',
      'areaServed': 'SE',
      'hoursAvailable': 'Mo,Tu,We,Th,Fr 09:00-19:00 CEST'
    },
    {
      '@type': 'ContactPoint',
      'contactType': 'Chat',
      'areaServed': 'SE',
      'hoursAvailable': 'Mo,Tu,We,Th,Fr 09:00-19:00 CEST',
      'url': `https://${host}/en-se`
    }
  ],
  'logo': {
    '@id': '#logo',
    'caption': 'Timberland',
    'contentUrl': `https://${host}/img/logo50.svg`,
    'url': `https://${host}/img/logo50.svg`
  },
  'name': 'Timberland',
  'parentOrganization': 'VF Corporation (VFC)',
  'sameAs': [
    'https://www.youtube.com/timberland',
    'https://www.instagram.com/timberland',
    'https://www.facebook.com/timberland'
  ],
  'url': `https://${host}/en-se`
})
